import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import { BaseCheckboxInput, DEPRECATED_Card, FormField, useTranslations } from "@jti/ui";
import { OrderAttributes } from "../../../../components/OrderAttributes";
import { useAemModel } from "../../../../contexts";
import { useShippingFormContext } from "../../hooks/useShippingFormContext";
import { ShippingContactBottom } from "./ShippingContactBottom";
import styles from "./ShippingContact.module.scss";
export const ShippingContact = ({ children, initialContactData, onEdit, isPhoneValidationErrorVisible, }) => {
    const { __ } = useTranslations();
    const { contactConfig } = useAemModel();
    const { watch, clearErrors, setValue } = useShippingFormContext();
    const code = watch("editPhone.code");
    const telephone = watch("editPhone.phone");
    const shouldUseAccountContact = watch("shouldUseAccountContact");
    const [sameRecipient, setSameRecipient] = useState(shouldUseAccountContact);
    const [phoneNumber, setPhoneNumber] = useState({
        code: code?.value,
        telephone,
    });
    const handleCheckboxChange = (event) => {
        const useAccount = event.target.checked;
        const phone = useAccount ? initialContactData?.telephone ?? "" : telephone;
        setValue("shouldUseAccountContact", useAccount);
        setSameRecipient(useAccount);
        setValue("shippingContact.telephone", phone);
    };
    useEffect(() => {
        if (shouldUseAccountContact) {
            clearErrors(["shippingContact", "editPhone"]);
        }
    }, [clearErrors, shouldUseAccountContact, initialContactData]);
    useEffect(() => {
        if (onEdit && (telephone !== phoneNumber?.telephone || code?.value !== phoneNumber.code)) {
            setPhoneNumber({ code: code?.value, telephone: telephone });
            onEdit(code?.value, telephone, "");
        }
    }, [code, telephone]);
    useEffect(() => {
        if (!initialContactData || !sameRecipient) {
            return;
        }
        setValue(`shippingContact.firstname`, initialContactData.firstname);
        setValue(`shippingContact.lastname`, initialContactData.lastname);
    }, [initialContactData?.firstname, initialContactData?.lastname, setValue]);
    return (_jsxs(DEPRECATED_Card, { title: __("cart.checkout.shipping_contact.title"), titleDataTestId: "card-container", variant: "variant4", children: [_jsx("div", { className: styles.intro, children: __("cart.checkout.shipping_contact.intro") }), !contactConfig?.differentRecipientDisabled && (_jsx(FormField, { id: "set-contact-details-editing", className: styles.useAccountContact, name: "useAccountContact", dataTestId: "set-contact-details-editing", render: ({ field }) => (_jsx(FormControlLabel, { ...field, label: __("cart.checkout.shipping_contact.use_account"), control: _jsx(BaseCheckboxInput, { className: styles.checkbox, id: "set-contact-details-editing-input", checked: sameRecipient, onChange: handleCheckboxChange }) })) })), _jsx(OrderAttributes, { target: "contactDetails_before" }), _jsx(ShippingContactBottom, { sameRecipient: sameRecipient, contact: initialContactData, isPhoneValidationErrorVisible: isPhoneValidationErrorVisible }), _jsx(OrderAttributes, { target: "contactDetails_after" }), children] }));
};
//# sourceMappingURL=ShippingContact.js.map